//
//
//
//
//
//
//
//
//
//

  import {resizeBaseDiv} from '../js/common/resize'

  export default {
  data () {
    return {
      indexContentHeight: 0
    }
  },
    mounted () {
      this.indexContentHeight = $(window).height();
    this.baiduGeoLocation();
      this.$nextTick(() => {
        resizeBaseDiv();
      })
  },methods:{
      baiduGeoLocation(){
        var geolocation = new BMap.Geolocation();
        var self = this;
        // 开启SDK辅助定位
        geolocation.enableSDKLocation();
        geolocation.getCurrentPosition(function(r){
          if(this.getStatus() == BMAP_STATUS_SUCCESS){
            var obj = {'lat':r.point.lat,'lng':r.point.lng};
            self.hagkHttp(self.hagkApi.geoLatLngToCityInfo(),obj).then(
                (res) => {
                    if(res.status){
                      var resultObj = res.result;
                      var code = "1"+resultObj.adCode;
                      var reginCode = code;
                      var regionName = resultObj.city+resultObj.district;
                      self.getLeagueCountIndex(regionName,reginCode);
                    }else{
                      console.log("获取当前位置失败")
                    }
                },
                (err) => {
                    console.log(err)
                }
              )
          }
          else {
            console.log('failed'+this.getStatus());
          }
        });
      },
      getLeagueCountIndex(regionName,regionCode){
          var self = this;
        this.hagkHttp(this.hagkApi.getLeagueCountIndex(regionCode), {}).then(
          (res) => {
            if(res.status){
                  var result = res.result;
                  var orgName = result.orgName;
                  var orgCode = result.orgCode;
                  var leagueCount = result.leagueCount;
                  if(result.orgCode == regionCode){
                      //if locatied place has league,location name is baidulocatied place name
                    orgName = regionName;
                  }
                  if(leagueCount > 0){
                    self.$router.replace({path:'index_region',query:{regionCode:orgCode,regionName:orgName}});
                  }else{
                    self.$router.replace({path:'public_index',query:{regionName:orgName,regionCode:orgCode}});
                  }
            }else{
                console.log("获取联赛数量异常")
            }
          },
          (err) => {console.log(err)}
        )
      }
  }
}



// WEBPACK FOOTER //
// ./src/views/welcome.vue